import _ from 'lodash';

export const showDownloadBillingPdfButton = (months, currentMonthId) => {
    const currentMonth = months.find(month => month.id === currentMonthId);
    const status = _.get(currentMonth, 'status', '');

    return status === 'AVAILABLE';
};
